































































































































































import { Component, Mixins } from "vue-property-decorator";

import MyList from "@/mixins/list";

import SelectUsers from "@/components/selectusers.vue";
import SelectStadium from "@/components/selectstadium.vue";

@Component({
  components: {
    SelectUsers,
    SelectStadium
  }
})
export default class extends Mixins(MyList) {
  refundModalVisible = false;
  stadiumForm!:any;
  oldData: any = {};
  stadium_id=0;
  stadiumModal=false;
  boxprice:any=5000;
  boxdeposit:any=5000;
  obj!:any;

  // 操作搜索栏的展开和折叠
  isFlag = false;

  dispatchType = "bill/deposit";

  columns: any[] = [
    { title: "编号", dataIndex: "id" },
    { title: "头像", scopedSlots: { customRender: "avatar" } },
    { title: "会员名/昵称", scopedSlots: { customRender: "username" } },
    { title: "城市", dataIndex: "city" },
    { title: "场馆", dataIndex: "stadium_name" },
    { title: "订单类型", scopedSlots: { customRender: "product_name" }},
    { title: "时间", dataIndex: "created_time" },
    { title: "金额", scopedSlots: { customRender: "fee" } },
    { title: "状态", scopedSlots: { customRender: "is_pay" } },
    { title: "操作", scopedSlots: { customRender: "action" } }
  ];

  mounted() {
    this.stadiumForm = this.$form.createForm(this);
    this.loadData();
    this.$store.dispatch("payments/opAIBoxPrice", {}).then(res=>{
      if (res && res.Message && res.Message === "success"){
        this.boxprice=(res.Data||500000)/100;
      }
    })
    this.$store.dispatch("payments/opAIBoxPrice", {flag:1}).then(res=>{
      if (res && res.Message && res.Message === "success"){
        this.boxdeposit=(res.Data||500000)/100;
      }
    })
  }

  handleCancel1(obj: any) {
    this.showTsConfirm({
      title: "确认信息",
      content: `你确定要取消该${obj.stadium_name}订单吗？`,
      onOk: async () => {
        const res = await this.$store.dispatch("bill/reject", {
          id: obj.id
        });
        if (res && res.Message && res.Message === "success") {
          this.$message.success(res.Message);
          this.loadData();
        } else {
          this.$message.error(res.Message);
        }
      }
    });
  }

  handlePrice() {
    this.form.validateFields((err: any, fieldsValue: any) => {
      if (!err) {
        const price=fieldsValue.boxprice;
        this.showTsConfirm({
          title: "确认信息",
          content: `你确定要更改AI体育盒子售价吗？`,
          onOk: async () => {
            const res = await this.$store.dispatch("payments/opAIBoxPrice", {
              price:price*100,
              op:1,
            });
            if (res && res.Message && res.Message === "success") {
              this.$message.success(res.Message);
            } else {
              this.$message.error(res.Message);
            }
          }
        });
      }
    });
  }

  handleDeposit() {
    this.form.validateFields((err: any, fieldsValue: any) => {
      if (!err) {
        const price=fieldsValue.boxdeposit;
        this.showTsConfirm({
          title: "确认信息",
          content: `你确定要更改AI体育盒子押金吗？`,
          onOk: async () => {
            const res = await this.$store.dispatch("payments/opAIBoxPrice", {
              flag:1,
              price:price*100,
              op:1,
            });
            if (res && res.Message && res.Message === "success") {
              this.$message.success(res.Message);
            } else {
              this.$message.error(res.Message);
            }
          }
        });
      }
    });
  }

  handleStadium(){
    this.hideStadiumModal()
    this.stadiumForm.validateFields((err: any, fieldsValue: any) => {
      if (!err) {
        const stadium_id=fieldsValue.stadium_id;
        this.showTsConfirm({
          title: "确认信息",
          content: `你确定要绑定场馆吗？`,
          onOk: async () => {
            const res = await this.$store.dispatch("bill/bindstadium", {
              id:this.obj.id,
              stadium_id: stadium_id,
            });
            if (res && res.Message && res.Message === "success") {
              this.$message.success(res.Message);
              this.loadData();
            } else {
              this.$message.error(res.Message);
            }
          }
        });
      }
    });
  }

  handleCancel2(obj: any) {
    this.showTsConfirm({
      title: "确认信息",
      content: `你确定要解绑场馆吗？`,
      onOk: async () => {
            const res = await this.$store.dispatch("bill/bindstadium", {
              id:obj.id,
              stadium_id: obj.type_id,
              cancel:1,
            });
            if (res && res.Message && res.Message === "success") {
              this.$message.success(res.Message);
              this.loadData();
            } else {
              this.$message.error(res.Message);
            }
      }
    });
  }


  hideStadiumModal(){
    this.stadiumModal=false;
  }

  showStadiumModal(record:any){
    this.obj=record;
    this.stadiumModal=true;
  }

}
